import React, { useEffect } from 'react'
import { useTranslate } from './TranslationText'
import { whiteCard } from '../common/cssclasses';
import { getOrdinal } from '../helper/getOrdinal';
import { useDispatch, useSelector } from 'react-redux';
import { clearOnAirData, clearRankData, subscribeToHorseOnAir, subscribeToTempRank } from '../Redux/actions/collectionActions';
// import { clearItems, clearItemsOnAir } from '../Redux/FireStore/collectionSlice';

export default function TempRanking({ showId }) {
    const { translate } = useTranslate();
    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = dispatch(subscribeToTempRank(showId));
        const onAirUnSub = dispatch(subscribeToHorseOnAir(showId));
        return () => {
            if (onAirUnSub) {
                onAirUnSub();
            }
            dispatch(clearOnAirData());
            if (unsubscribe) {
                unsubscribe();
            }
            dispatch(clearRankData());
        };
    }, [dispatch, showId]);

    // Use the real-time data from the store in this component
    const { data, loading, error } = useSelector(state => state.showTemporaryRank);

    const { inArenaHorseId, viewHorseBox, inArenaHorse } = useSelector(state => state.horseOnAir);

    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';

    return (
        data?.length > 0 &&
        <div className="col-xl-4 col-lg-4 col-md-12 mb-2 ">
            <div className={whiteCard} style={{ maxHeight: 685, overflowY: "auto" }}>
                <h4 className='bold' >{currentLanguage == 'en' ? data?.at(-1)?.ClassName : data?.at(-1)?.ClassNameAr}</h4>
                <div className='d-flex justify-content-between'>
                    <h5 className='bold' >{translate('web.temporaryRank', 'Temporary Rank')}</h5>
                    <h6 className='bold' >{data?.at(-1)?.RankScoringList?.length} <img className='ms-2' src='./svgs/horse-head-solid.svg' style={{ height: 15 }} /></h6>
                </div>
                <table className="table tablenominwidth table-striped table-bordered rtl horseResultTable" style={{ direction: currentLanguage == "en" ? "ltr" : "rtl", width: '100%', minWidth: 0 }}>
                    <thead className='text-center bg-success'
                        style={{
                            color: "white",
                        }}
                    >
                        <th style={{ padding: '.5rem' }}>
                            {translate("web.rank", "Rank")}
                        </th>
                        <th className='text-start' style={{ padding: '.5rem' }}>{translate("web.horseName", "Horse Name")}</th>
                        <th style={{ padding: '.5rem' }}>{translate("web.totalPoints", "Total Points")}</th>
                    </thead>
                    <tbody className='text-center'>
                        {data?.at(-1)?.RankScoringList?.map((x) => (
                            <tr >
                                {!!x?.HorseRank ?
                                    <td className='bold' dangerouslySetInnerHTML={{ __html: getOrdinal(x?.HorseRank) }} /> :
                                    <td className='bold' dangerouslySetInnerHTML={{ __html: "-" }} />
                                }
                                <td className='bold text-start'>
                                    {x?.HorseNumber} - {currentLanguage == 'en' ? x?.HorseName : x?.HorseNameAr}
                                </td>
                                {(inArenaHorseId?.toLowerCase() === x?.HorseId?.toLowerCase() && !!inArenaHorse?.HorseInArenaName && (x?.TotalScore <= 0 || !x?.TotalScore)) ? <><td className='bold' > <span className='p-2 rounded ' > <i className='fa fa-circle  w-unset' style={{ color: '#dc3545' }} ></i>  {translate('web.liveHorse', 'Live')}</span></td></> :
                                    <td className='bold' >{x?.TotalScore != 0 && x?.TotalScore?.toFixed(2)} {!!x?.Reason && x.Reason} </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    )
}
